module.exports = __webpack_public_path__ + "media/banks/bank-suntrust-c0e23cb5.png";